import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getMyInvoices } from '../../services/invoiceService';
import { getMyNotifications } from '../../services/notificationService';
import { getMySubscription } from '../../services/subscriptionService';
import { getMyServiceRequests } from '../../services/serviceRequestService'; // دالة جديدة
import { Invoice } from '../../types/invoice';
import { Notification } from '../../types/notification';
import { Subscription } from '../../types/subscription';
import { ServiceRequest } from '../../types/serviceRequest';
import styles from './LawyerDashboardPage.module.css'; // ملف تنسيقات جديد وجذاب
import {FaSignOutAlt, FaUser, FaFileInvoice, FaBell, FaCalendarCheck, FaListAlt } from 'react-icons/fa';
import pageStyles from '../Page.module.css';
import Icon from '../../components/common/Icon';

const LawyerDashboardPage: React.FC = () => {
    const { user, logout } = useAuth(); // (4) استخراج دالة logout من السياق
  const navigate = useNavigate(); // (5) تهيئة useNavigate
  
  
  const [subscription, setSubscription] = useState<Subscription | null>(null);
  const [invoices, setInvoices] = useState<Invoice[]>([]);
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [requests, setRequests] = useState<ServiceRequest[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setIsLoading(false);
      return;
    }
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const subPromise = getMySubscription();
        const invoicesPromise = getMyInvoices();
        const notifsPromise = getMyNotifications(user.id); 
        const requestsPromise = getMyServiceRequests(); // دالة جديدة لجلب طلبات المستخدم الحالي

        const [subRes, invoicesRes, notifsRes, requestsRes] = await Promise.all([
          subPromise,
          invoicesPromise,
          notifsPromise,
          requestsPromise,
        ]);

        setSubscription(subRes);
        setInvoices(invoicesRes);
        setNotifications(notifsRes);
        setRequests(requestsRes);
      } catch (error) {
        console.error("Failed to fetch dashboard data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [user]);
  
   // (6) إنشاء دالة لمعالجة تسجيل الخروج
  const handleLogout = () => {
    logout(); // استدعاء دالة تسجيل الخروج من السياق
    navigate('/directory'); // توجيه المستخدم إلى صفحة تسجيل الدخول
  };
  if (isLoading) {
    return <div className={styles.loading}>جاري تحميل لوحة التحكم...</div>;
  }

  return (
    <div className={styles.dashboardContainer}>
      <header className={styles.header}>
        <h2>أهلاً بك، المحامي {user?.name}</h2>
        <p>هذه هي لوحة التحكم الخاصة بك لإدارة جميع أنشطتك.</p>
        <button onClick={handleLogout} className={styles.logoutButton}>
          <Icon as={FaSignOutAlt} style={pageStyles.icon } />
          <span>تسجيل الخروج</span>
        </button>
      </header>

      <div className={styles.dashboardGrid}>
        {/* Card: Subscription Status */}
        <div className={`${styles.card} ${styles.subscriptionCard}`}>
          <div className={styles.cardHeader}>
            <Icon as={FaCalendarCheck} style={pageStyles.icon } />
            <h3>حالة الاشتراك</h3>
          </div>
          <div className={styles.cardBody}>
            {subscription ? (
              <>
                <p>الحالة: <span className={styles[subscription.status]}>{subscription.status}</span></p>
                <p>تاريخ الانتهاء: {new Date(subscription.end_date).toLocaleDateString('ar-EG')}</p>
                <button className={styles.actionButton}>تجديد الاشتراك</button>
              </>
            ) : (
              <p>لا يوجد اشتراك حالي.</p>
            )}
          </div>
        </div>

        {/* Card: Latest Invoices */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
             <Icon as={FaFileInvoice} style={pageStyles.icon } />
            <h3>آخر الفواتير</h3>
          </div>
          <div className={styles.cardBody}>
            <ul className={styles.dataList}>
              {invoices.slice(0, 3).map(inv => (
                <li key={inv.id}>
                  <span>فاتورة #{inv.id}</span>
                  <span className={styles[inv.status]}>{inv.status}</span>
                </li>
              ))}
            </ul>
            <button className={styles.actionButton}>عرض كل الفواتير</button>
          </div>
        </div>

        {/* Card: Latest Service Requests */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <Icon as={FaListAlt} style={pageStyles.icon } />
            <h3>آخر طلبات الخدمات</h3>
          </div>
          <div className={styles.cardBody}>
            <ul className={styles.dataList}>
              {requests.slice(0, 3).map(req => (
                <li key={req.id}>
                  <span>{req.service?.name}</span>
                  <span className={styles[req.status]}>{req.status}</span>
                </li>
              ))}
            </ul>
            <button className={styles.actionButton}>عرض كل الطلبات</button>
          </div>
        </div>

        {/* Card: Latest Notifications */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
             <Icon as={FaBell} style={pageStyles.icon } />
            <h3>آخر التنبيهات</h3>
          </div>
          <div className={styles.cardBody}>
            <ul className={styles.dataList}>
              {notifications.slice(0, 3).map(notif => (
                <li key={notif.id}>
                  <span>{notif.title}</span>
                  <span className={styles[notif.status]}>{notif.status}</span>
                </li>
              ))}
            </ul>
            <button className={styles.actionButton}>عرض كل التنبيهات</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LawyerDashboardPage;
